import React from 'react';
import { isMacOS } from '@/helpers';
import MacOSIcon from '@/icons/shortcuts/macos/duplicate-content-icon.inline.svg';
import WindowsOSIcon from '@/icons/shortcuts/windows/duplicate-content-icon.inline.svg';

const DuplicateContentIcon = () => {
  const macOS = isMacOS();

  if (macOS) {
    return <MacOSIcon />;
  }
  return <WindowsOSIcon />;
};

export default DuplicateContentIcon;
